import type { ToastContentProps } from '@repo/go-ui';
import { createNotification } from '@repo/go-ui';
import { secondsToMilliseconds } from 'date-fns';
import { observer } from 'mobx-react-lite';

import type { TNotification } from '../../AnomalyNotificationsService';
import { ALERT_NOTIFICATIONS_CONTAINER_ID } from '../AlertNotifications.consts';

import { AlertNotification } from './AlertNotification';

type CreateAlertNotificationOptions = Omit<
  Parameters<typeof createNotification>[0],
  'closeButton' | 'containerId' | 'content' | 'position'
> & {
  notification: TNotification;
};

type AlertNotificationToastContentProps = Pick<ToastContentProps, 'closeToast'> & {
  notification: TNotification;
};

const AlertNotificationToastContent = observer(function AlertNotificationToastContent({
  closeToast,
  notification,
}: AlertNotificationToastContentProps) {
  return <AlertNotification notification={notification} onClose={closeToast} />;
});

export function createAlertNotification({ notification, onClose, ...options }: CreateAlertNotificationOptions) {
  const toastId = createNotification({
    autoClose:
      notification.infoWindowDurationSeconds > 0
        ? secondsToMilliseconds(notification.infoWindowDurationSeconds)
        : false,
    containerId: ALERT_NOTIFICATIONS_CONTAINER_ID,
    content: ({ closeToast }) => <AlertNotificationToastContent closeToast={closeToast} notification={notification} />,
    draggable: false,
    hideProgressBar: true,
    onClose,
    style: {
      marginBottom: '4px',
    },
    ...options,
  });

  return toastId;
}
